import * as React from 'react';
import { IFilterableListFacet, IFilterableListFacetTerm } from '../../../../global/dtos/filterable-list-results-dto';
import { IFacetResult, FieldNames, ITerm } from '../../../../search-page/state-helpers/facets';
import { IDropdownOption, defaultDivider } from '../../../../global/state-helpers/filters';
import { DropdownSelect } from '../selects/dropdown-select';

interface IProps {
    facet: IFacetResult;
    facets: IFacetResult[];
    index: number;
    pinnedCountryNames?: string[];
    pinnedSubspecialties?: string[];
    onUpdateSearchFacet: (facets: IFacetResult[]) => void;
    removeSelectText?: boolean;
}

interface IState {

}

export class DropdownFacet extends React.Component<IProps, IState> {

    render() {
        const { onUpdateSearchFacet, facet, removeSelectText } = this.props;

        let items = facet.terms.map(t => Object.freeze({
            id: t.id.toString(),
            display: t.displayTerm,
            selected: t.selected,
            isDisabled: false
        })) as IDropdownOption[];

        // Add pinned items to the top of the dropdown
        let pinnedItems = this.getPinnedItems(items);

        // Add the empty placeholder
        let empty = {
            display: `${removeSelectText ? '' : 'Select'} ${facet.name}`,
            id: "",
            selected: facet.terms.some(x => x.selected)[0] ? facet.terms.filter(x => x.selected)[0] : false,
            isDisabled: false,
        } as IDropdownOption;
        pinnedItems.unshift(empty);

        let dropdownOptions = [].concat(pinnedItems, items);

        return <DropdownSelect values={dropdownOptions} placeHolder={`Select ${facet.name}`} display={facet.name} disabled={this.getDisabled(facet)} name={facet.fieldName}
            onDropdownSelect={(id: string) => onUpdateSearchFacet(this.mapDropdownFacets(id, facet))} />
    }

    getPinnedItems = (items: IDropdownOption[]) => {
        const { pinnedCountryNames, pinnedSubspecialties, facet } = this.props;

        var pinnedItems = [];
        var toPin = [];
        if (pinnedCountryNames && facet.fieldName.toLowerCase() === FieldNames.Countries) {
            toPin = pinnedCountryNames;
        }
        else if (pinnedSubspecialties && facet.fieldName.toLowerCase() === FieldNames.Subspecialties) {
            toPin = pinnedSubspecialties
        }

        if (toPin && toPin.length > 0) {
            [].forEach.call(toPin, (pin) => {
                var value = pin.toLowerCase();
                if (items.some(x => x.display.toLowerCase() === value)) {
                    // Make sure we mark pinned items with isPinned: true
                    pinnedItems.push({ ...items.filter(x => x.display.toLowerCase() === value)[0], isPinned: true });
                }
            });

            // Add the disabled divider
            if (pinnedItems.length > 0) {
                pinnedItems.push(defaultDivider);
            }
        }

        return pinnedItems;
    }

    getDisabled = (currentFacet: IFacetResult) => {
        if (currentFacet.fieldName.toLowerCase() === FieldNames.States) {
            let countries = this.props.facets.filter(f => f.fieldName.toLowerCase() === FieldNames.Countries)[0];
            return countries && countries.terms.some(t => t.selected) ? false : true;
        }
        return false;
    }

    getDropdownSelected = (id: string, facet: IFacetResult, f: IFacetResult, t: ITerm) => {
        // If this is the current term, toggle it
        if (t.id === parseInt(id)) {
            return !t.selected;
        }
        // if countries is set to placeholder, unselect states 
        if ((f.fieldName.toLowerCase() === FieldNames.States && facet.fieldName.toLowerCase() === FieldNames.Countries && !id)
            //or if this is a term in the current facet, set it to off
            || f.fieldName === facet.fieldName) {
            return false;
        }
        // Otherwise leave as is
        return t.selected;
    }

    getDropdownTerms = (id: string, facet: IFacetResult, f: IFacetResult) => {
        if (id === '' && f.fieldName === facet.fieldName) {
            return [];
        }

        return f.terms.map(t => ({
            ...t,
            selected: this.getDropdownSelected(id, facet, f, t)
        }))
    }

    mapDropdownFacets = (id: string, facet: IFacetResult) => {
        return this.props.facets.map(f => ({
            ...f,
            // Reset the terms for this facet when the placeholder is chosen
            terms: this.getDropdownTerms(id, facet, f)
        }));
    }
}

